const hasOrganiserRights = user => user?.clientUserRoles?.organiser === true

export default hasOrganiserRights